// extracted by mini-css-extract-plugin
module.exports = {"item":"TextSelect_item__2HQhW"};